import React from "react";
import { ShoppingBag } from "lucide-react";

import { reais } from "../lib/numeros";
import LinhaItemCompra from "./LinhaItemCompra";

// Coluna da direita: tudo o que já entrou nesta compra (as ações ficam no rodapé).
export default function ItensDaCompra({ c, mediaDe, editando, aoVer, aoEditar }) {
  const n = c.itens.length;
  return (
    <section className="h-full rounded-xl border bg-card overflow-hidden flex flex-col" data-e2e="itens-compra">
      <div className="shrink-0 px-4 sm:px-5 py-4 border-b bg-gradient-to-br from-card to-primary/5">
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            <ShoppingBag className="w-4 h-4 text-primary" />
            <h2 className="font-semibold">Itens da compra</h2>
          </div>
          <span className={`text-xs px-2 py-0.5 rounded-full tabular-nums ${n ? "bg-primary/15 text-primary font-semibold" : "bg-muted text-muted-foreground"}`}>
            {n} {n === 1 ? "item" : "itens"}
          </span>
        </div>
        <p className="text-2xl font-bold tabular-nums tracking-tight mt-1" data-e2e="total-compra">{reais(c.total)}</p>
      </div>

      {n === 0 ? (
        <div className="flex-1 flex flex-col items-center justify-center text-center px-6 py-12">
          <div className="w-14 h-14 rounded-full bg-muted/60 flex items-center justify-center mb-3"><ShoppingBag className="w-6 h-6 text-muted-foreground/70" strokeWidth={1.5} /></div>
          <p className="font-medium text-muted-foreground">Nenhum item ainda</p>
          <p className="text-xs text-muted-foreground/80 mt-1 max-w-[240px]">Lance o ingrediente ao lado e toque em "Adicionar à compra".</p>
        </div>
      ) : (
        <ul className="flex-1 overflow-y-auto divide-y">
          {c.itens.map((item) => (
            <LinhaItemCompra key={item.id} item={item} ing={c.porId.get(item.ingredient_id)} media={mediaDe(item.ingredient_id)}
              emEdicao={editando === item.id} aoVer={() => aoVer(item)} aoEditar={() => aoEditar(item)} aoRemover={() => c.remover(item.id)} />
          ))}
        </ul>
      )}
    </section>
  );
}
